import React, { useCallback, useState } from 'react'
import NavigationHeder from '../../../components/Navigations/NavigationHeder'; 
import Settings from '../../../inc/Settings';
import Helper from '../../../inc/Helper';
import { exportToXlsx, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Api from '../../../inc/Api';
import NewOverlayLoader from '../../../components/PurchaseRequisition/common/NewOverlayLoader';
import AgGridNew from '../../../components/grid/ag/ag-grid-new';
import MasterComponentWraper from '../../../components/Backend/MasterComponentWraper';
import { connect } from 'react-redux';
import { generateBaseUrl } from '../../../components/grid/ag/commonFunctions/GridCommonFunctions';
import axios from 'axios';

let gridApi = null;
let AddBtn;
let transaction;

const Stages = (props) => {
  const [exportLoading, setExportLoading] = useState(false);

  const gridColumnHeader = [
    { field: 'name', headerName: 'Name', editable: true }
  ];
  
  const handleBtn = (value, transactionData) => {
    AddBtn = value
    transaction = transactionData
  };

  const onRowValueChanged = (event) => {  
    if (!event?.data?.stage_id) {
      addStages(event);
    } else {
      updatedStages(event);
    }
  };

  const addStages = async (event) => {
    try {
      let payload = [{
        name: event?.data?.name,
        tenant_id: props?.user?.tenant_id,
      }];

      let api = Api;
      api.setUserToken()
 
      const res = await api.axios().post(Settings.baseUrl + 'stage/create', payload);
      if (res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        setTimeout(() => {
          if (AddBtn) {
            gridApi?.api?.applyServerSideTransaction(transaction);
          }
        }, 1000);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error);
    }  
  };

  const updatedStages = async (event) => { 
    try {
      let payload = [{
        name: event?.data?.name,
        stage_id: event?.data?.stage_id
      }];
  
      let api = Api;
      api.setUserToken()
      const res = await api.axios().post(Settings.baseUrl + 'stage/update', payload);
      if (res.data.success) {
        setTimeout(() => {
          gridApi?.api?.refreshServerSide({ purge: true });
          gridApi?.api?.deselectAll();
        }, 100);
        Helper.alert(res?.data?.message);
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error);
    }
  };

  const onDeleteStage = useCallback(async (element) => {
    try {
      let api = Api;
      api.setUserToken()
      const res = await
        api.axios()
        .post(Settings.baseUrl + 'stage/delete', { stage_id: [element?.data?.stage_id] })
      const rowNode = gridApi?.api?.getRowNode(element?.data?.stage_id)
      if (rowNode) {
        rowNode.setSelected(false)
      }

      setTimeout(() => {
        const transaction = { remove: [element.data] }
        gridApi?.api?.applyServerSideTransaction(transaction)
      }, 200);

      gridApi?.api?.refreshServerSide({ purge: true })
      gridApi?.api?.deselectAll();

      Helper.alert(res?.data?.message, 'success')
    } catch (err) {
      getPopupMessageBasedOnStatus(err)
    }
  }, []);

  const exportData = async () => {
    setExportLoading(true);

    const apiUrl = `${Settings.baseUrl}stage/get/${props?.user?.tenant_id}`;
    const params = '';

    let pagination = false;
    let defaultAdvanceFilterObj = false; 

    const baseUrl = generateBaseUrl({ gridObj: gridApi, apiUrl, params, pagination, defaultAdvanceFilterObj });
    await exportToXlsx({ url: baseUrl, columns: (gridColumnHeader), fileName: "stage_details", apiTokenRequired: false });
    
    setExportLoading(false);
  };
  
  return (
    <> 
      <NavigationHeder title={`<span style="color:#000;"> Home > </span>  ${'Stages'}`} hideBackButton={true} />

      {exportLoading ? <NewOverlayLoader /> : null}

      <div className='rs_form_grid'>
        <AgGridNew
          apiUrl={`${Settings.baseUrl}stage/get/${props?.user?.tenant_id}`}
          pagination={false}
          columnDefs={gridColumnHeader}
          onRowValueChanged={onRowValueChanged}
          handleDeleteSelectedRows={onDeleteStage}
          height={500}
          onGridReady={(params) => gridApi = params}
          handleAddButton={handleBtn}
          uniqueField={`stage_id`}
          hideDeleteBtn={true}
          apiTokenRequired={false}
          hideDeleteBtn={true}
          gridId={'stages-workflow-forms'}
          afterDeleteBtns={
            <div className="import_sample_template px-2 ms-auto">
              <button onClick={exportData}>
                <img className="img-fluid" src="/images/icons/excel-logo.svg" alt="excel-logo" /> Export
              </button>
            </div>
          }
          btnsWrapperStyle="w-100 px-2"
        />
      </div> 
    </>
  )
}

const mapStateToProps = (state) => {
  return { 
    user: state.auth.user
  }
};

export default connect(mapStateToProps) (MasterComponentWraper(Stages));